var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-rank-list__one-column pr" },
    [
      !_vm.styleObject.hideHeader
        ? _c(
            "rank-title",
            {
              ref: "rankTitle",
              staticClass: "mb16",
              on: {
                changeDate: function ($event) {
                  return _vm.$emit("changeDate", $event)
                },
              },
            },
            [
              _c(
                "div",
                { attrs: { slot: "title" }, slot: "title" },
                [_vm._t("title")],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm.isFixed
        ? _c(
            "div",
            { staticClass: "yxtbiz-rank-list__one-column-rank-box-fixed" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "flex standard-size-14 text-8c yxtbiz-rank-list__one-column-rank-box mb16 ml8 mr8",
                },
                [
                  _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      { staticClass: "mr12 yxtbiz-rank-list__one-column-rank" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("pc_biz_rank_rank").d("排名")) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm.contentObj.primaryCode
                      ? _c("div", [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.contentObj.objectName) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "yxtbiz-rank-list__one-column-rank-attributeName-box",
                    },
                    [
                      _c(
                        "yxt-tooltip",
                        {
                          attrs: {
                            effect: "light",
                            "open-filter": "",
                            placement: "top",
                            content:
                              _vm.$t(_vm.contentObj.attributeName) +
                              (_vm.contentObj.attributeCode === "learningTime"
                                ? "(min)"
                                : ""),
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "yxtbiz-rank-list__one-column-rank-attributeName",
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t(_vm.contentObj.attributeName)) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm.contentObj.attributeCode === "learningTime"
                        ? _c("div", [_vm._v("(min)")])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        {
          class: {
            "yxtbiz-rank-list__one-column-no-data":
              _vm.height &&
              (!_vm.rankData.rankList || !_vm.rankData.rankList.length),
          },
          style: { height: _vm.height ? _vm.height - 88 + "px" : "auto" },
        },
        [
          _vm.rankData.rankList && _vm.rankData.rankList.length
            ? _c(
                "yxtf-scrollbar",
                { ref: "scrollBox", attrs: { "fit-height": "" } },
                [
                  _vm.styleObject.showStyle === 2
                    ? _c("horizontal-head", {
                        attrs: {
                          "rank-data": _vm.rankData.rankList.slice(
                            0,
                            _vm.sliceNum
                          ),
                        },
                      })
                    : _vm._e(),
                  !_vm.styleObject.hideMyRank &&
                  _vm.contentObj.objectCode === "user"
                    ? _c("my-rank", {
                        staticClass: "mb16",
                        attrs: {
                          myRankData: _vm.rankData.myRankData,
                          styleType: 1,
                        },
                      })
                    : _vm._e(),
                  _vm.rankData.rankList.length > _vm.sliceNum
                    ? _c(
                        "div",
                        {
                          ref: "listTitle",
                          staticClass:
                            "flex standard-size-14 text-8c yxtbiz-rank-list__one-column-rank-box mb4 ml8 mr8",
                        },
                        [
                          _c("div", { staticClass: "flex" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "mr12 yxtbiz-rank-list__one-column-rank",
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t("pc_biz_rank_rank").d("排名")
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm.contentObj.primaryCode
                              ? _c("div", [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.contentObj.objectName) +
                                      "\n          "
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass:
                                "yxtbiz-rank-list__one-column-rank-attributeName-box",
                            },
                            [
                              _c(
                                "yxt-tooltip",
                                {
                                  attrs: {
                                    effect: "light",
                                    "open-filter": "",
                                    placement: "top",
                                    content:
                                      _vm.$t(_vm.contentObj.attributeName) +
                                      (_vm.contentObj.attributeCode ===
                                      "learningTime"
                                        ? "(min)"
                                        : ""),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "yxtbiz-rank-list__one-column-rank-attributeName",
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(_vm.contentObj.attributeName)
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm.contentObj.attributeCode === "learningTime"
                                ? _c("div", [_vm._v("(min)")])
                                : _vm._e(),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    _vm._l(
                      _vm.rankData.rankList.slice(_vm.sliceNum),
                      function (item, index) {
                        return _c(
                          "div",
                          { key: index },
                          [_c("row-item", { attrs: { rowData: item } })],
                          1
                        )
                      }
                    ),
                    0
                  ),
                ],
                1
              )
            : _c("div", [
                _vm.initFlag < 1
                  ? _c(
                      "div",
                      [
                        _vm.errorTip === "pc_biz_rank_calculating"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "flex yxtbiz-rank-list__one-column-calculating",
                              },
                              [
                                _c("yxtf-svg", {
                                  attrs: {
                                    width: "16px",
                                    height: "16px",
                                    "icon-class": "loading",
                                  },
                                }),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "standard-size-14 text-8c yxtbiz-rank-list__one-column-calculating-tip",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("pc_biz_rank_calculating"))
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _c("yxtf-empty", {
                              attrs: {
                                size: "small",
                                "empty-text": _vm.$t(_vm.errorTip),
                              },
                            }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }